import request from '../shared/lib/request';
import constants from '../shared/constants';

const tokenKey = "auth_tokenKey";
const tokenExpiryKey = 'tokenExpiry';
const localStorageKey = 'loggedIn';
const userInfoKey = 'userInfo';

var data = { 
  emailOrLogin: "",
  password: "",
  idSoftware: process.env.VUE_APP_SOFTWARE_ID
};

async function login(payload) {
  data.emailOrLogin = payload.userDetails.email;
  data.password = payload.userDetails.password;

  var response = await request({
    url:    '/authentication',
    method: 'POST',
    data: data,
    baseURL: constants.auth.baseUrl
  });

  console.log(response);

  localStorage.setItem(tokenExpiryKey, 12312323);
  localStorage.setItem(localStorageKey, 'true');
  localStorage.setItem(tokenKey, response.data.accessToken);

  return response;
}

function getUserInfo() {
  var response = {
    data: {
      displayName: "Ola",
      email: "Ola",
      photoURL: "https://s.gravatar.com/avatar/d2ade63f847870546de221ecef1278c0?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fal.png",
      uid: "auth0|5d8b28bc3994d10df0d5dff2"
    }
  }
  
  localStorage.setItem(userInfoKey, JSON.stringify({
      displayName: response.data.displayName,
      email: response.data.email,
      photoURL: response.data.photoURL,
      uid: response.data.uid
  }));

  return response;
}

function logout() {
  return request({
    url:    '/authentication',
    method: 'DELETE',
    baseURL: constants.auth.baseUrl
  });
}

const AccessControlService = {
  login, logout, getUserInfo
}

export default AccessControlService;